/* eslint-disable camelcase */
  <template >
  <div v-role="'func'">
    <br>
  <div>
  <div class="formPosition">

<v-form
    ref="form"
    v-model="valid"
    lazy-validation
>
  <v-row>
    <template>
      <v-card style="margin:auto;" width="1200">
        <v-overlay :value="overlay">
      <v-progress-circular
        indeterminate
        size="64"
      ></v-progress-circular>
    </v-overlay>
        <v-container   style="background-color:#006699; color:white;border-bottom:1px solid white;">
      <div>
         <span>Informações sobre os cliente</span>
         <v-tooltip left>
        <template v-slot:activator="{ on, attrs }">
          <v-icon v-bind="attrs"
            v-on="on" style="float:right;color:white;">info
          </v-icon>
        </template>
        <span>Clique aqui para saber como criar um novo Produto</span>
      </v-tooltip>
      </div>
  </v-container>
        <v-tabs
          v-model="tab"
          background-color="#006699"
          dark
        >
          <v-tab
            v-for="item in items"
            :key="item.tab"
          >
            {{ item.tab }}
          </v-tab>
        </v-tabs>

        <!-- ===================================== DIALOGO DE SELEÇÃO DO CLIENTE INICIAL================================= -->
                 <template>
               <v-row justify="center">
                <v-dialog v-model="dialog"  max-width="800px">
                  <v-card>
                    <v-card-title>
                      <span class="headline">Selecione o intervalo de Filtragem</span>
                    </v-card-title>
                    <v-card-text>
                      <v-container>
                        <v-row>
                            <v-col md="12">
                               <v-data-table :headers="headers" :items="clientes">
                                  <template v-slot:item.selecione="{ item }">
                                     <v-tooltip bottom>
                                        <template v-slot:activator="{ on, attrs }">
                                          <v-btn color="#006699" style="color:white;" @click="SelecionaClienteInicial(item)" v-on="on" v-bind="attrs" fab small><v-icon>done</v-icon></v-btn>
                                        </template>
                                        <span>Clique neste botão para selecionar este Cliente.</span>
                                    </v-tooltip>
                                  </template>
                               </v-data-table>
                            </v-col>
                        </v-row>
                      </v-container>
                    </v-card-text>
                  </v-card>
                </v-dialog>
              </v-row>
            </template>

        <!-- ====================================== Fim do DIALOGO =============================================== -->

        <!-- ===================================== DIALOGO DE SELEÇÃO DO CLIENTE FINAL================================= -->
                 <template>
               <v-row justify="center">
                <v-dialog v-model="dialogFinal"  max-width="800px">
                  <v-card>
                    <v-card-title>
                      <span class="headline">Selecione o intervalo de Filtragem</span>
                    </v-card-title>
                    <v-card-text>
                      <v-container>
                        <v-row>
                            <v-col md="12">
                               <v-data-table :headers="headers" :items="clientes">
                                  <template v-slot:item.selecione="{ item }">
                                     <v-tooltip bottom>
                                        <template v-slot:activator="{ on, attrs }">
                                          <v-btn color="#006699" style="color:white" @click="SelecionaClienteFinal(item)" v-on="on" v-bind="attrs" fab small><v-icon>done</v-icon></v-btn>
                                        </template>
                                        <span>Clique neste botão para selecionar este Cliente.</span>
                                    </v-tooltip>
                                  </template>
                               </v-data-table>
                            </v-col>
                        </v-row>
                      </v-container>
                    </v-card-text>
                  </v-card>
                </v-dialog>
              </v-row>
            </template>

        <!-- ====================================== Fim do DIALOGO =============================================== -->

        <v-tabs-items v-model="tab">
          <!--======================== Tab Geral ========================================-->
          <v-tab-item>
              <v-card flat>
                    <v-alert
                      v-model="alert"
                      dismissible
                      :type="alertType"
                      border="left"
                      :icon="iconAlert"
                      transition="scale-transition"
                      :style="colorAlert"
                      elevation="2"
                      colored-border
                    >
                    {{msgAlert}}
                  </v-alert>
                  <v-card-title>

                  </v-card-title>
                    <v-card-text>
                      <table style="width:100%;">
                        <tr>
                          <td  style="width:80%;">
                              <p style="margin-left:-10px;font-weight:bold;">Critérios de Filtragem e Ordenação</p>
                              <v-row style="border:1px solid #ccc;width:700px;margin-top:-15px;">
                                <v-col md="6"><span>Filtragem por:</span>
                                  <v-select
                                        v-model="filtragemSelecionada"
                                        :items="campos"
                                        item-text="descricao"
                                        item-value="descricao"
                                        label="Selecione o campo"
                                        color="white;"
                                        @change="SelecionaFiltragem()"
                                      ></v-select>
                                </v-col>
                                <v-col md="6"><span>E ordenada por:</span>
                                  <v-select
                                        v-model="ordenacaoSelecionada"
                                        :items="campos"
                                        item-text="descricao"
                                        item-value="descricao"
                                        label="Selecione o campo"
                                        color="white;"
                                      ></v-select>
                                </v-col>
                              <v-col md="5">
                                <span>{{filtragemInicial}}</span>
                                <v-text-field  label="Inicio" v-model="txtInicial" ></v-text-field>
                                </v-col>
                                <v-col md="1">
                                  <v-btn fab small @click="PesquisarCliente()" style="margin-top:33px;margin-left:-10px;"><v-icon>search</v-icon></v-btn>
                                </v-col>
                                <v-col md="5"><span>{{filtragemFinal}}</span>
                                  <v-text-field  v-model="txtFinal" label="Fim" ></v-text-field>
                                </v-col>
                                <v-col md="1">
                                    <v-btn fab small @click="PesquisarClienteFinal()"  style="margin-top:33px;margin-left:-10px;"><v-icon>search</v-icon></v-btn>
                                </v-col>
                              </v-row>
                          </td>
                           <td>
                             <span style="font-size:16px;font-weight:bold;">Descrição:</span><span> Listagem Simples</span>
                             <div style="border:1px solid #cccccc;">
                               <p style="padding:10px;">Lista os clientes e seus dados( Nome completo,Número de Contribuinte, telefone ).</p>
                             </div>
                               <p style="margin-left:-10px;font-weight:bold;">Botões de Ação/Exportação</p>
                              <v-row style="border:1px solid #ccc;width:420px;margin-top:-15px;background-color:#006699;">
                                <v-col md="4">
                                    <v-tooltip bottom>
                                        <template v-slot:activator="{ on, attrs }">
                                          <v-btn color="green"
                                            fab
                                            v-bind="attrs"
                                            v-on="on"
                                            @click="CarregarTabela()"
                                            style="color:white;">
                                            <v-icon>restore</v-icon>
                                          </v-btn>
                                        </template>
                                        <span>Clique neste botão para visualizar os dados, que serão apresentados segundo os critérios de filtragem e ordenação.</span>
                                    </v-tooltip>
                                </v-col>
                                <v-col md="4">
                                  <v-tooltip bottom>
                                        <template v-slot:activator="{ on, attrs }">
                                          <v-btn fab
                                          v-bind="attrs"
                                            v-on="on"
                                           color="white" >
                                            <img width="30px" src="../../assets/pdf_exibir.png">
                                          </v-btn>
                                        </template>
                                        <span>Clique aqui para exportar os dados em PDF.</span>
                                   </v-tooltip>
                                </v-col>
                                <v-col md="4">
                                  <v-tooltip bottom>
                                        <template v-slot:activator="{ on, attrs }">
                                          <v-btn
                                          fab
                                           v-bind="attrs"
                                            v-on="on"
                                          color="white"
                                          >
                                            <img width="30px" src="../../assets/download.png">
                                          </v-btn>
                                        </template>
                                        <span>Clique aqui para exportar os dados em Excel.</span>
                                   </v-tooltip>
                                </v-col>
                              </v-row>
                            </td>
                        </tr>
                      </table>
                    </v-card-text>
                  </v-card>
          </v-tab-item>
          <!--====================== END Tab Geral ========================================================================= -->
          <!--======================== Tab Geral ========================================-->
          <v-tab-item>
              <v-card flat>
                    <v-alert
                      v-model="alert"
                      dismissible
                      :type="alertType"
                      border="left"
                      :icon="iconAlert"
                      transition="scale-transition"
                      :style="colorAlert"
                      elevation="2"
                      colored-border
                    >
                    {{msgAlert}}
                  </v-alert>
                  <v-card-title>

                  </v-card-title>
                    <v-card-text>
                      <table style="width:100%;">
                        <tr>
                          <td  style="width:80%;">
                              <p style="margin-left:-10px;font-weight:bold;">Critérios de Filtragem e Ordenação</p>
                              <v-row style="border:1px solid #ccc;width:700px;margin-top:-15px;">
                                <v-col md="6"><span>Filtragem por:</span>
                                  <v-select
                                        v-model="filtragemSelecionada"
                                        :items="campos"
                                        item-text="descricao"
                                        item-value="descricao"
                                        label="Selecione o campo"
                                        color="white;"
                                        @change="SelecionaFiltragem()"
                                      ></v-select>
                                </v-col>
                                <v-col md="6"><span>E ordenada por:</span>
                                  <v-select
                                        v-model="ordenacaoSelecionada"
                                        :items="campos"
                                        item-text="descricao"
                                        item-value="descricao"
                                        label="Selecione o campo"
                                        color="white;"
                                      ></v-select>
                                </v-col>
                              <v-col md="5">
                                <span>{{filtragemInicial}}</span>
                                <v-text-field  label="Inicio" v-model="txtInicial" ></v-text-field>
                                </v-col>
                                <v-col md="1">
                                  <v-btn fab small @click="PesquisarCliente()" style="margin-top:33px;margin-left:-10px;"><v-icon>search</v-icon></v-btn>
                                </v-col>
                                <v-col md="5"><span>{{filtragemFinal}}</span>
                                  <v-text-field  v-model="txtFinal" label="Fim" ></v-text-field>
                                </v-col>
                                <v-col md="1">
                                    <v-btn fab small @click="PesquisarClienteFinal()"  style="margin-top:33px;margin-left:-10px;"><v-icon>search</v-icon></v-btn>
                                </v-col>
                              </v-row>
                          </td>
                           <td>
                             <span style="font-size:16px;font-weight:bold;">Descrição:</span><span> Listagem Simples</span>
                             <div style="border:1px solid #cccccc;">
                               <p style="padding:10px;">Lista os clientes e seus dados( Nome completo,Número de Contribuinte, telefone ).</p>
                             </div>
                               <p style="margin-left:-10px;font-weight:bold;">Botões de Ação/Exportação</p>
                              <v-row style="border:1px solid #ccc;width:420px;margin-top:-15px;background-color:#006699;">
                                <v-col md="4">
                                    <v-tooltip bottom>
                                        <template v-slot:activator="{ on, attrs }">
                                          <v-btn color="green"
                                            fab
                                            v-bind="attrs"
                                            v-on="on"
                                            @click="CarregarTabela()"
                                            style="color:white;">
                                            <v-icon>restore</v-icon>
                                          </v-btn>
                                        </template>
                                        <span>Clique neste botão para visualizar os dados, que serão apresentados segundo os critérios de filtragem e ordenação.</span>
                                    </v-tooltip>
                                </v-col>
                                <v-col md="4">
                                  <v-tooltip bottom>
                                        <template v-slot:activator="{ on, attrs }">
                                          <v-btn fab
                                          v-bind="attrs"
                                            v-on="on"
                                           color="white" >
                                            <img width="30px" src="../../assets/pdf_exibir.png">
                                          </v-btn>
                                        </template>
                                        <span>Clique aqui para exportar os dados em PDF.</span>
                                   </v-tooltip>
                                </v-col>
                                <v-col md="4">
                                  <v-tooltip bottom>
                                        <template v-slot:activator="{ on, attrs }">
                                          <v-btn
                                          fab
                                           v-bind="attrs"
                                            v-on="on"
                                          color="white"
                                          >
                                            <img width="30px" src="../../assets/download.png">
                                          </v-btn>
                                        </template>
                                        <span>Clique aqui para exportar os dados em Excel.</span>
                                   </v-tooltip>
                                </v-col>
                              </v-row>
                            </td>
                        </tr>
                      </table>
                    </v-card-text>
                  </v-card>
          </v-tab-item>
          <!--====================== END Tab Geral ========================================================================= -->

          <!--======================== Tab Listagem 3 ========================================-->
          <v-tab-item>
              <v-card flat>
                    <v-alert
                      v-model="alert"
                      dismissible
                      :type="alertType"
                      border="left"
                      :icon="iconAlert"
                      transition="scale-transition"
                      :style="colorAlert"
                      elevation="2"
                      colored-border
                    >
                    {{msgAlert}}
                  </v-alert>
                  <v-card-title>

                  </v-card-title>
                    <v-card-text>
                      <table style="width:100%;">
                        <tr>
                          <td  style="width:80%;">
                              <p style="margin-left:-10px;font-weight:bold;">Critérios de Filtragem e Ordenação</p>
                              <v-row style="border:1px solid #ccc;width:700px;margin-top:-15px;">
                                <v-col md="6"><span>Filtragem por:</span>
                                  <v-select
                                        v-model="filtragemSelecionada"
                                        :items="campos"
                                        item-text="descricao"
                                        item-value="descricao"
                                        label="Selecione o campo"
                                        color="white;"
                                        @change="SelecionaFiltragem()"
                                      ></v-select>
                                </v-col>
                                <v-col md="6"><span>E ordenada por:</span>
                                  <v-select
                                        v-model="ordenacaoSelecionada"
                                        :items="campos"
                                        item-text="descricao"
                                        item-value="descricao"
                                        label="Selecione o campo"
                                        color="white;"
                                      ></v-select>
                                </v-col>
                              <v-col md="5">
                                <span>{{filtragemInicial}}</span>
                                <v-text-field  label="Inicio" v-model="txtInicial" ></v-text-field>
                                </v-col>
                                <v-col md="1">
                                  <v-btn fab small @click="PesquisarCliente()" style="margin-top:33px;margin-left:-10px;"><v-icon>search</v-icon></v-btn>
                                </v-col>
                                <v-col md="5"><span>{{filtragemFinal}}</span>
                                  <v-text-field  v-model="txtFinal" label="Fim" ></v-text-field>
                                </v-col>
                                <v-col md="1">
                                    <v-btn fab small @click="PesquisarClienteFinal()"  style="margin-top:33px;margin-left:-10px;"><v-icon>search</v-icon></v-btn>
                                </v-col>
                              </v-row>
                          </td>
                           <td>
                             <span style="font-size:16px;font-weight:bold;">Descrição:</span><span> Produtos por Clientes</span>
                             <div style="border:1px solid #cccccc;">
                               <p style="padding:10px;">Lista os clientes e quais produtos foram movimentados pelos mesmos.</p>
                             </div>
                               <p style="margin-left:-10px;font-weight:bold;">Botões de Ação/Exportação</p>
                              <v-row style="border:1px solid #ccc;width:420px;margin-top:-15px;background-color:#006699;">
                                <v-col md="4">
                                    <v-tooltip bottom>
                                        <template v-slot:activator="{ on, attrs }">
                                          <v-btn color="green"
                                            fab
                                            v-bind="attrs"
                                            v-on="on"
                                            @click="CarregarTabela()"
                                            style="color:white;">
                                            <v-icon>restore</v-icon>
                                          </v-btn>
                                        </template>
                                        <span>Clique neste botão para visualizar os dados, que serão apresentados segundo os critérios de filtragem e ordenação.</span>
                                    </v-tooltip>
                                </v-col>
                                <v-col md="4">
                                  <v-tooltip bottom>
                                        <template v-slot:activator="{ on, attrs }">
                                          <v-btn fab
                                          v-bind="attrs"
                                            v-on="on"
                                           color="white" >
                                            <img width="30px" src="../../assets/pdf_exibir.png">
                                          </v-btn>
                                        </template>
                                        <span>Clique aqui para exportar os dados em PDF.</span>
                                   </v-tooltip>
                                </v-col>
                                <v-col md="4">
                                  <v-tooltip bottom>
                                        <template v-slot:activator="{ on, attrs }">
                                          <v-btn
                                          fab
                                           v-bind="attrs"
                                            v-on="on"
                                          color="white"
                                          >
                                            <img width="30px" src="../../assets/download.png">
                                          </v-btn>
                                        </template>
                                        <span>Clique aqui para exportar os dados em Excel.</span>
                                   </v-tooltip>
                                </v-col>
                              </v-row>
                            </td>
                        </tr>
                      </table>
                    </v-card-text>
                  </v-card>
          </v-tab-item>
          <!--====================== END Tab Geral ========================================================================= -->
        </v-tabs-items>
      </v-card>
    </template>

  </v-row>
  </v-form>
  </div>
</div>
</div>
</template>
My CRUD
<script>

import axios from '../../plugins/axios'
import { mask } from 'vue-the-mask'
import utilitarios from '../../plugins/utilitarios'
const ls = require('local-storage')
// const axios = require('../plugins/axios')
export default {
  directives: { mask },
  data: () => ({
    isLoading_: false,
    search: '',
    menuFab: null,
    menuExp: null,
    produtosDesconto: [],
    filtragemSelecionada: null,
    ordenacaoSelecionada: null,
    clientes: [],
    opcaodescontoglobal: null,
    opcaoSelecionada: null,
    descontoFlag: false,
    flagDescontoGlobal: false,
    dataExpiracao: '',
    dataFabrico: '',
    txtInicial: null,
    txtFinal: null,
    produtoSelecionado: null,
    valid: true,
    overlay: false,
    produtos: [],
    alert: false,
    filtragemInicial: 'Código inicial',
    filtragemFinal: 'Código final',
    iconAlert: '',
    alertType: '',
    campo: 'codigo',
    campoOrdenacao: '',
    colorAlert: '',
    dialogFinal: false,
    dialog: false,
    msgAlert: '',
    y: 'top',
    text: 'mensagem nao setada.',
    //  timeout: 4000,
    editedIndex: -1,
    editedItem: {
      nome: '',
      nif: '',
      tipoFornecedor: '',
      morada: '',
      telefone1: '',
      telefone2: '',
      email: '',
      observacao: ''
    },
    tab: null,
    items: [
      { tab: 'Lista de clientes', content: 'Tab 1 Content' }
      // { tab: 'Produtos por Cliente', content: 'Tab 1 Content' }
    ],

    editedItemProduto: {
      produto: '',
      preco: '',
      desconto: '',
      descontoGlobal: ''
    },

    tipoFornecedor:
    [
      { descricao: 'Muito Bom' },
      { descricao: 'Bom' },
      { descricao: 'Médio' }
    ],
    itemsSimNao:
    [
      { id: 1, descricao: 'Sim' },
      { id: 2, descricao: 'Não' }
    ],
    headers: [
      {
        text: 'Código',
        align: 'start',
        sortable: false,
        value: 'pk_estudante'
      },
      { text: 'Nome', value: 'nome' },
      { text: 'Nº de Contribuinte', value: 'nif' },
      { text: 'Telefone', value: 'telefone' },
      { text: 'Selecione aqui', value: 'selecione' }
    ],
    campos: [
      { descricao: 'Código' },
      { descricao: 'Nome' },
      { descricao: 'Nif' }
    ],
    ruleRequired: [value => !!value || 'campo obrigatorio'],
    ruleTextRequired: [
      value => !!value || 'campo obrigatório.',
      value =>
        (value || '').length <= 50 || 'O máximo número de carácters atigidos',

      value => (value || '').length > 3 || 'carácteres insuficientes',
      value => {
        const pattern = /(([{;=+~_!@#$%^&*()/,.?":{}|<>},{0-9}]))$/
        return !pattern.test(value) || 'Invalido.'
      }
    ],
    ruleBI: [

      value => value.length === 16 || 'Minimo de caracteres exigido( 16 ).'
    ],
    ruleNumberNObrigatorio: [
      value => {
        const pattern = /^[0-9]+([,.][0-9]+)?$/g
        return pattern.test(value) || 'O valor deve ser numerico.'
      }
    ],
    ruleNumber: [
      value => !!value || 'campo obrigatório.',
      value => {
        const pattern = /^[0-9]*$/
        return pattern.test(value) || 'O valor deve ser numerico.'
      }
    ],
    ruleEmailRequired: [
      //  value => !!value || 'Required.',
      value => value.length <= 50 || 'O máximo número de carácters atigidos',
      value => {
        const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
        return pattern.test(value) || 'Invalid e-mail.'
      }
    ]
  }),

  computed: {
    formTitle () {
      return this.editedIndex === -1 ? 'Inser novo Estudante' : 'Editar dados de Estudante'
    },
    loggedUserName () {
      return ls.get('nomeUsuario')
    },
    idclasse () {
      return this.$store.state.idclasse
    },
    computeddatanascimento () {
      // eslint-disable-next-line no-undef
      return this.editedItem.datanascimento ? moment(this.editedItem.datanascimento).format('dddd, MMMM Do YYYY') : ''
    },
    computedDateFormattedDatefns () {
      // eslint-disable-next-line no-undef
      return this.date ? format(this.date, 'dddd, MMMM Do YYYY') : ''
    },
    textMessage () {
      return this.$store.state.textMessage
    },
    classMessage () {
      return this.$store.state.classMessage
    },
    hasMessage () {
      return this.$store.state.hasMessage
    },

    ListaActividades () {
      return ls.get('lista_actividades')
    },

    returnImagem () {
      return this.imageData
    }

  },

  watch: {
    menuFab (val) {
      val && setTimeout(() => (this.$refs.picker.activePicker = 'YEAR'))
    },
    menuExp (val) {
      val && setTimeout(() => (this.$refs.picker.activePicker = 'YEAR'))
    },
    estudantes () {
      this.isLoading = false
      this.$store.state.isloading = false
    },
    dialog (val) {
      val || this.close()
    },
    model (val) {
      if (val.length > 1) {
        this.$nextTick(() => this.model.pop())
      }
    },
    search (val) {
      // Items have already been loaded
      if (val.length >= 4) {
      // Items have already been requested
        if (!this.produtos.filter(t => t.descricao.includes(val)).length) {
          this.produtos = []
          return this.initializeProdutos(val)
        }
      }

      if (val.length >= 4) { return this.initializeProdutos(val) }
    }

  },

  created () {
    // check if classe has been selected otherwise send back to painel to select
    this.ClientesFindAll()
    this.filtragemSelecionada = this.campos[0]
    this.ordenacaoSelecionada = this.campos[0]
  },

  methods: {
    Continuar () {
      if (this.$refs.form.validate()) {
        this.tab = 1
      }
    },
    async Save () {
      if (this.$refs.form.validate()) {
        let params =
          {
            pk_estudante: 0,
            nome: this.editedItem.nome,
            nif: this.editedItem.nif,
            morada: this.editedItem.morada,
            telefone1: this.editedItem.telefone1,
            telefone2: this.editedItem.telefone2,
            email: this.editedItem.email,
            observacao: this.editedItem.observacao,
            produtosDesconto: this.produtosDesconto,
            descontoPorProduto: this.opcaoSelecionada,
            OpcaodescontoGlobal: this.opcaodescontoglobal,
            descontoGlobal: this.editedItemProduto.descontoGlobal
          }
        try {
        //   let  payload =""
          let msg = await axios
            .post('/clienteInsertOrUpdate', params)
            .then(res => res.data)

          if (msg) {
            this.showAlertSucess()
            this.Limpar()
          }
        } catch (error) {
          this.text = error
          this.$store.dispatch('textMessage', { 'msg': this.text, 'classMessage': 'msgError', 'timeout': 3000 })
        }
      }
    },

    async ClientesFindAll () {
      try {
        //   let  payload =""
        this.overlay = true
        this.clientes = await axios
          .get('/clienteFindAlll')
          .then(res => res.data)
        this.overlay = false
      } catch (error) {
        this.overlay = false

        this.text = error
        this.$store.dispatch('textMessage', { 'msg': this.text, 'classMessage': 'msgError', 'timeout': 3000 })
      }
    },

    SelecionaAplicacao () {
      if (this.opcaoSelecionada === 1) {
        this.descontoFlag = true
      } else { this.descontoFlag = false }
    },

    SelecionaDescontoGlobal () {
      if (this.opcaodescontoglobal === 1) {
        this.flagDescontoGlobal = true
      } else { this.flagDescontoGlobal = false }
    },

    AdicionarTabela () {
      this.editedItemProduto.produto = this.produtoSelecionado.produto
      this.editedItemProduto.preco = utilitarios.IntegerToMoneyValue(this.produtoSelecionado.preco)
    },

    Eliminar (item) {
      let index = this.produtosDesconto.indexOf(item)
      this.produtosDesconto.splice(index, 1)
    },

    AdicionarDesconto () {
      let preco = parseFloat(this.produtoSelecionado.preco)
      let desconto = parseFloat(this.editedItemProduto.desconto)
      let valorDesconto = utilitarios.ObterValorDaPercentagem(preco, desconto)

      let obj = { percentagem: this.editedItemProduto.desconto, valor: valorDesconto, produto: this.produtoSelecionado.pkProduto, descricao: this.produtoSelecionado.codigoBarra + ' - ' + this.produtoSelecionado.produto + ' - ' + this.editedItemProduto.desconto + '%' + ' - ' + utilitarios.IntegerToMoneyValue(valorDesconto) }
      this.produtosDesconto.push(obj)
    },

    showAlertSucess () {
      this.alert = true
      this.tab = 0
      this.colorAlert = 'color:green;'
      this.iconAlert = 'done'
      this.alertType = 'success'
      this.msgAlert = 'Cliente  registrado com sucesso!'
      setTimeout(() => {
        this.alert = false
      }, 4000)
    },

    // METHODO FOR VALIDATION
    validate () {
      if (this.$refs.form.validate()) {

      } else {
        console.log('elso foraaa')
      }
    },
    reset () {
      this.$refs.form.reset()
      this.Limpar()
    },
    resetValidation () {
      this.$refs.form.resetValidation()
    },

    Limpar () {
      this.editedItem.nome = ''
      this.editedItem.nif = ''
      this.editedItem.tipoFornecedor = ''
      this.editedItem.morada = ''
      this.editedItem.telefone1 = ''
      this.editedItem.telefone2 = ''
      this.editedItem.email = ''
      this.editedItem.observacao = ''
    },
    SelecionaFiltragem () {
      if (this.filtragemSelecionada === 'Código') { this.filtragemInicial = 'Código inicial'; this.filtragemFinal = 'Código final'; this.campo = 'codigo' };
      if (this.filtragemSelecionada === 'Nome') { this.filtragemInicial = 'Nome inicial'; this.filtragemFinal = 'Nome final'; this.campo = 'nome' };
      if (this.filtragemSelecionada === 'Nif') { this.filtragemInicial = 'Nif inicial'; this.filtragemFinal = 'Nif final'; this.campo = 'nif' };
    },
    PesquisarCliente () {
      this.dialog = true
    },
    PesquisarClienteFinal () {
      this.dialogFinal = true
    },
    SelecionaClienteInicial (item) {
      if (this.campo === 'codigo') { this.txtInicial = item.pk_estudante }
      if (this.campo === 'nome') { this.txtInicial = item.nome }
      if (this.campo === 'nif') { this.txtInicial = item.numero_documento }
      this.dialog = false
    },
    SelecionaClienteFinal (item) {
      if (this.campo === 'codigo') { this.txtFinal = item.pk_estudante }
      if (this.campo === 'nome') { this.txtFinal = item.nome }
      if (this.campo === 'nif') { this.txtFinal = item.numero_documento }
      this.dialogFinal = false
    },
    CarregarTabela () {
      let params =
       {
         campo: this.campo,
         inicial: this.txtInicial,
         final: this.txtFinal
       }

      this.$store.state.camposListagemCliente = params
      this.$router.push('listagemSimples-cliente')
    }
  }
}
</script>
<style scoped>

.btn_space {
  margin-bottom:5px;
}

.btn_add_align {
  margin-top:10px;
}
.file-upload-form, .image-preview {
    font-family: "Helvetica Neue",Helvetica,Arial,sans-serif;
    padding: 20px;
}
img.preview {
    background-color: white;
    border: 1px solid #DDD;
    padding: 5px;
}

</style>
